export default "__VITE_ASSET__BvN$cyhW__"